import { render, staticRenderFns } from "./CartArea.vue?vue&type=template&id=32baef20&scoped=true&"
import script from "./CartArea.vue?vue&type=script&lang=js&"
export * from "./CartArea.vue?vue&type=script&lang=js&"
import style0 from "./CartArea.vue?vue&type=style&index=0&id=32baef20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32baef20",
  null
  
)

export default component.exports